module.exports = __webpack_public_path__ + "img/airplane.a1f3b412.gif";